import { Component } from 'react';
import { connect } from 'react-redux';

import { Button, Heading, Pane } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';
import { getShortUrl, updateShortUrl } from '../actions/ShortUrlActions';
import ShortUrlForm from '../components/ShortUrlForm';

import { Link } from 'react-router-dom';

import Configuration from '../Config';

const validation = Configuration.Validations.editShortUrl;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditShortUrl extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    componentDidMount() {
        this.props.dispatch(getShortUrl(this.id));
    }

    handleSave = (values) => {
        this.props.dispatch(updateShortUrl(this.props.shortUrl.id, values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/short-urls">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista short URLs
                            </Button>
                        </Link>
                    </Pane>

                    <Pane marginLeft={16}>
                        <Link to={`/short-urls/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Atribut - <strong>{this.props.shortUrl.name}</strong>
                    </Heading>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <ShortUrlForm
                            isEdit={true}
                            initialValues={this.props.shortUrl}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.shortUrls.errors.type === 'validation' ? mapValidationErrors(state.shortUrls.errors.fields): [],
        shortUrl: state.shortUrls.current
    }
}

export default connect(mapStateToProps)(EditShortUrl);
